import * as yup from "yup";

export const feedInsertSettingsSchema = yup.object({
  showInsertsAfterSpecifiedNumberOfProducts: yup
    .number()
    .min(8, "Must be greater than 8")
    .max(100, "Must be less than 100")
    .required("Required")
});
